import { useMediaQuery } from '@mui/material';
import SortableTableHead from 'Components/TableBase/SortableTableHead';
import { StyledTable } from 'Components/TableBase/Table';
import React, { useMemo } from 'react';
import theme from 'styles/theme';
import { IPlot } from 'FeatureModules/Site/types/plot.types';
import PlotsTableBody from './PlotsTableBody';
import { EPlotsTableColumnKeys, plotsHeaderColumns } from './plotsHeaderColumns';

interface IPlotsTableProps {
  hideHeaderColumn?: boolean;
  columns: EPlotsTableColumnKeys[];
  plots: IPlot[];
  onEdit: (plot: IPlot) => void;
  onClick: (plot: IPlot) => void;
  onDelete?: (plot: IPlot) => void;
}

const PlotsTable: React.FC<IPlotsTableProps> = ({
  columns,
  hideHeaderColumn,
  plots,
  onEdit,
  onClick,
  onDelete,
}) => {
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));
  const isExtraSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  const shownColumns = useMemo(
    () =>
      plotsHeaderColumns.filter(
        ({ id }) =>
          columns.includes(id) &&
          (isSmallScreen || isExtraSmallScreen
            ? id !== EPlotsTableColumnKeys.CREATED_TIMESTAMP
            : true) &&
          (isExtraSmallScreen ? id !== EPlotsTableColumnKeys.ACTIONS : true)
      ),
    [columns, isSmallScreen, isExtraSmallScreen]
  );

  return (
    <>
      <StyledTable aria-labelledby="tableTitle" aria-label="enhanced table">
        {!hideHeaderColumn && <SortableTableHead headerColumns={shownColumns} />}
        <PlotsTableBody
          plots={plots}
          headerColumns={shownColumns}
          onEdit={onEdit}
          onClick={onClick}
          onDelete={onDelete}
        />
      </StyledTable>
    </>
  );
};

export default PlotsTable;
